import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import {
  URL_USERS_ADMIN_REPORT,
  URL_USERS_BRAND,
  URL_USERS_DETAIL_USER,
  URL_USERS_DIGITAL_SIGNATURE,
  URL_USERS_ECOMMERCE,
  URL_USERS_NEW,
  URL_USERS_OTHER_PASSWORD,
  URL_USERS_OWN_PASSWORD,
  URL_USERS_PASSWORD_POLICY,
  URL_USERS_REGISTER_USER,
  URL_USERS_SEARCH,
  URL_USERS_SEARCH_OPERATIONS,
  URL_USERS_WHITELIST,
} from '@app/@core/constants/routes.constants';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { CredentialsService, AuthenticationService } from '@app/login';

@Injectable({
  providedIn: 'root',
})
export class UsersGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log(state.url);
    if (this.credentialsService.isAuthenticated()) {
      if (
        //TODO-Jed: Is it been used?
        state.url === URL_USERS_NEW &&
        this.authenticationService.permissionURL(URL_USERS_NEW) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_WHITELIST &&
        this.authenticationService.permissionURL(URL_USERS_WHITELIST) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_MAINTENANCE_WHITE)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_BRAND &&
        this.authenticationService.permissionURL(URL_USERS_BRAND) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_MAINTENANCE_BRAND)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_DIGITAL_SIGNATURE &&
        this.authenticationService.permissionURL(URL_USERS_DIGITAL_SIGNATURE) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_DIGITAL_SIGNATURE_REPORT)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_ECOMMERCE &&
        this.authenticationService.permissionURL(URL_USERS_ECOMMERCE) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ECCOMERCE_REPORT)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_PASSWORD_POLICY &&
        this.authenticationService.permissionURL(URL_USERS_PASSWORD_POLICY) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PASSWORD_POLICIES)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_ADMIN_REPORT &&
        this.authenticationService.permissionURL(URL_USERS_ADMIN_REPORT) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ADMINISTRATOR_REPORT)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_OWN_PASSWORD &&
        this.authenticationService.permissionURL(URL_USERS_OWN_PASSWORD) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CHANGE_OWN_PASSWORD)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_OTHER_PASSWORD &&
        this.authenticationService.permissionURL(URL_USERS_OTHER_PASSWORD) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CHANGE_PASSWORD)
      ) {
        return true;
      } else if (
        state.url.includes(URL_USERS_SEARCH_OPERATIONS) &&
        this.authenticationService.permissionURL(URL_USERS_SEARCH_OPERATIONS) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION)
      ) {
        return true;
      } else if (
        (state.url.includes(URL_USERS_SEARCH) || state.url === URL_USERS_DETAIL_USER) &&
        this.authenticationService.permissionURL(URL_USERS_SEARCH) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_USER)
      ) {
        return true;
      } else if (
        state.url === URL_USERS_REGISTER_USER &&
        this.authenticationService.permissionURL(URL_USERS_REGISTER_USER) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_USERS)
      ) {
        return true;
      } else {
        this.router.navigate(['/**'], { replaceUrl: true });
        return false;
      }
    } else {
      return false;
    }
  }
}
